import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LicService from '../../../../services/licitacao-auth';
import InfiniteScroll from '../../utils/infiniteScroll';
import Licitacao from './lic';


const ListarLicAndamento = () => {


    async function fetchLics() {
        await seraQueAcabou();
        const response = await LicService.listar({ cod_lic: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numLic / 20) + 1
            for (let i = 1; i < count; i++) {
                setLics([...lics, ...response.data])
                setCod(response.data[response.data.length-1]["cod_lic"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setLics([])
            setVazio(true)
        }
    }

    const [lics, setLics] = useState([]);
    const [situacao, setSituacao] = useState(false);
    const [valor, setValor] = useState(false);
    const [arquivo, setArquivo] = useState(false);
    const [objeto, setObjeto] = useState(null);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [lic, setLic] = useState("");
    const [cod, setCod] = useState(null);
    const [numLic, setNumLic] = useState(null);
    const [aindaTem, setAindaTem] = useState();
    const [verLic, setVerLic] = useState(false);


    async function fetchLicsIn() {
        await pegaNumLic();
        const response = await LicService.listar();
        if (response.data.length >= 1) {
            setLics(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_lic"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setLics([])
            setVazio(true)
        }
    }

    async function pegaNumLic() {
        const response = await LicService.numLic({ todas: true })
        setNumLic(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (lics.length >= numLic) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }

    const handleEditar = (id) => {
        setLic(id);
        setEditar(true)
    }

    const handleVer = (id) => {
        setLic(id);
        setVerLic(true)
    }

    const handleObjeto = (id) => {
        setLic(id);
        setObjeto(true)
    }

    const handleValor = (id) => {
        setLic(id);
        setValor(true)
    }

    const handleSituacao = (id) => {
        setLic(id);
        setSituacao(true)
    }

    const handleArquivo = (id) => {
        setLic(id);
        setArquivo(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a licitação?')) {
            await LicService.deletar(id)
            alert("Licitação deletada com sucesso!")
            fetchLics();
        }
    }

    useEffect(() => {
        fetchLicsIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/licitacao/editar/${lic}`} />
        )
    } else if (situacao) {
        return (
            <Navigate to={`/restrito/licitacao/situacao/${lic}`} />
        )
    } else if (valor) {
        return (
            <Navigate to={`/restrito/licitacao/valor/${lic}`} />
        )
    } else if (arquivo) {
        return (
            <Navigate to={`/restrito/licitacao/anexos/${lic}`} />
        )
    } else if (objeto) {
        return (
            <Navigate to={`/restrito/licitacao/objeto/${lic}`} />
        )
    }
    else if (verLic) {
        return (
            <Navigate to={`/restrito/licitacao/licitacao/${lic}`} />
        )
    }
    else {
        return (
            <Fragment>
                <h2>Exibindo TODAS licitações cadastradas!</h2><br/><br/>
                <Fragment>
                    <FormBusca
                        setLics={setLics}
                        setVazio={setVazio}
                        setAindaTem={setAindaTem}
                        fetchLicsIn={fetchLicsIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1}>
                            {lics.map((lic, index) =>
                                <Licitacao
                                    fetchLicsIn={fetchLicsIn}
                                    lic={lic}
                                    key={index}
                                    editar={handleEditar}
                                    ver={handleVer}
                                    arquivo={handleArquivo}
                                    objeto={handleObjeto}
                                    valor={handleValor}
                                    situacao={handleSituacao}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                        {aindaTem ?
                            <Fragment>
                                <p>Carregando mais licitações...</p>
                                <InfiniteScroll Listar={fetchLics} />
                            </Fragment>
                            : <p>Todas as licitações já foram exibidas :)</p>}
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarLicAndamento;